import gql from 'graphql-tag';

import type { Utilities, UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { TopicFromSlugQuery } from './index.graphql';

export async function getTopicSlug(
	slug: string,
	// Utilities support is currently necessary for this to be called by route config
	utilities: UtilityContext | Pick<Utilities, 'gql'>,
): Promise<string | undefined> {
	const { data } = await utilities.gql.fetch<TopicFromSlugQuery>({
		query: gql`
			query TopicFromSlug($slug: String!) {
				topic: topicPageBySlug(slug: $slug) {
					slug
					id
				}
			}
		`,
		variables: { slug },
	});
	return data?.topic?.slug ?? undefined;
}
